/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = MaterialPaymentItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialPaymentItemsEditor extends _Ext.ItemGridEditor<MaterialPaymentItemsRow> {
        protected getColumnsKey() { return "Sales.MaterialPaymentItems"; }
        protected getDialogType() { return MaterialPaymentItemsDialog; }
        protected getLocalTextPrefix() { return MaterialPaymentItemsRow.localTextPrefix; }

        protected form: MaterialPaymentItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
 

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public TransDate: Date;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        statement: string;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as MaterialPaymentDialog).CalculateAmountandTax(this.view.getItems());
                }
            })
        }
      
        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({SKU: SKU
                
            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {

                    Quantity += x.Pieces;

                };

                if (Quantity > 0) {
                    var Item = StockID.pop();


                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            //Q.first(columns, x => x.field === fld.Discount).format = num;
            //Q.first(columns, x => x.field === fld.WstPer).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion
 
        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('This will effect Stock and can not be undone, Are you sure want to delete? ', () => {
                        /*if (item.TransItemId > 0) {

                            // **** Validate StockId from Stock Transactions ****
                            let StockID;
                            Stock.StockItemService.GetStockTransactions({
                                LineNo: item.Line_No,
                                RefTransId: item.TransId,
                                ProductId: item.ProductId,
                                Take: 1
                            },
                                response => StockID = response.Entities,
                                {
                                    async: false
                                });

                            //Q.alert
                            if (StockID.length > 0) {
                                Q.alert("This Item is used in other transactions, Can Not Delete!!");
                                return;
                            }
                            else {
                                Sales.MaterialPaymentItemsService.Delete({ EntityId: item.TransItemId });
                                StockID.foreach(function (value) {
                                    Stock.StockItemService.Delete({ EntityId: value.StockId });

                                });
                                
                                var id = this.id(item);
                                this.TotalItems = this.view.getItems().length - 1;
                                this.view.deleteItem(id);
                            }
                        }
                        else {*/
                            var id = this.id(item);
                            this.TotalItems = this.view.getItems().length - 1;
                            this.view.deleteItem(id);
                        //}

                    });
                    (this.parentDialog as MaterialPaymentDialog).CalculateAmountandTax(this.view.getItems());
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        
        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as MaterialPaymentDialog).CalculateAmountandTax(this.view.getItems());

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion

        setMasterValues() {
            this.RateListId = (this.parentDialog as MaterialPaymentDialog).RateListId;
            this.LaborListId = (this.parentDialog as MaterialPaymentDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as MaterialPaymentDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as MaterialPaymentDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as MaterialPaymentDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as MaterialPaymentDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as MaterialPaymentDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as MaterialPaymentDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as MaterialPaymentDialog).form.PartyId.value);
        }
        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            var grid = Stock.StockForMaterialSelectGrid;

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    this.setMasterValues();

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    }
                    else {
                        
                        var grid = Common.StockSelectGrid;
                        var filters: _Ext.SelectGridFilters = {
                            FilterItems: 6, 
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var Items = []; 
                        var companyId = Q.Authorization.userDefinition.CompanyId; 
                        
                        var userDetails = Q.Authorization.userDefinition;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value) {
                            var PrdId = value.ProductId; 
                            var PrdDetails = value;

                            // #region Product Attributes
                            // **** Load & assign Attributes of Product using AtbID ****
                            let ATBDetails = value;
                            var BaseItm = ATBDetails.ProductTypeId;
                            var ItemTypeId = ATBDetails.ItemTypeId;
                            var Type = ATBDetails.CategoryName;
                            var CategoryId = ATBDetails.CategoryId;
                            var SubType = ATBDetails.SubCategoryName;
                            var SubCategoryId = ATBDetails.SubCategoryId;
                            var Brand = ATBDetails.BrandName;
                            var BrandId = ATBDetails.BrandId;
                            var SuperType = ATBDetails.SuperTypeName;
                            var SuperTypeId = ATBDetails.SuperTypeId;
                            var Collection = ATBDetails.CollectionName;
                            var CollectionId = ATBDetails.CollectionId;
                            var CalcOn = PrdDetails.CalcOnId;
                            var Weight = value.Weight == undefined ? 1 : value.Weight;
                            var purity = 0;
                            var pureweight = 0;
                            if (!value.HasBom) {
                                purity = value.Purity;
                                pureweight = value.Weight * purity;
                            }

                            if (!value.HasBom) {
                                Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                                var MRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == PrdDetails.MetalId && x.RateTypeId == 33
                                    && x.CompanyId == userDetails.CompanyId && Q.formatDate(x.FromDate, "dd/MM/yyyy") <= Q.formatDate(self.TransDate, "dd/MM/yyyy"));
                                Rate = MRate.pop().Rate;
                                var KaratId = Q.toId(ATBDetails.KaratId);
                                var puritydetails: OMS.AttributeMasterRow;
                                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                    puritydetails = response.Entity
                                }, { async: false });
                                var std = puritydetails.StdPurity;
                                purity = std;
                                value.Purity = std;
                            }
                            // #endregion

                            var Rate = 0;
                            var LaborRate = 0;
                        
                            var Sales: MaterialPaymentItemsRow = {
                                ProductId: PrdId,
                                AttributeId: PrdDetails.AttributeId,
                                Line_No: value.LineNo,
                                PartyId: self.PartyId,
                                SKU: value.SKU,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: CategoryId,
                                ProductTypeId: BaseItm,
                                SubCategoryId: SubCategoryId,
                                BrandId: BrandId,
                                SuperTypeId: SuperTypeId,
                                CollectionId: CollectionId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                Pieces: value.Pieces,
                                Weight: Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                TaxCode: value.TaxCode,
                                NetAmount: PrdDetails.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
                                GrossAmount: PrdDetails.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: CalcOn,
                                CompanyId: companyId,
                                HSN: value.HSN,
                                RefTransId: value.TransId,
                                Purity: purity,
                                PureWeight: pureweight,
                                HasBom: value.HasBom,
                                BagNo: value.BagNo,
                                CertificateNo: value.CertificateNo,
                                LotNo: value.LotNo,
                                Studded: value.Studded,
                                StockAllocation:value.StockAllocation

                            };
                            Items.push(Sales);

                        });

                        for (let Item of Items) {
                            Item[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Item);
                            this.view.refresh();
                        }

                    }
                    // #endregion
                    
                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
         
    }
}